import { render, staticRenderFns } from "./modal-dialog.vue?vue&type=template&id=684d2880&scoped=true&"
import script from "./modal-dialog.vue?vue&type=script&lang=js&"
export * from "./modal-dialog.vue?vue&type=script&lang=js&"
import style0 from "./modal-dialog.vue?vue&type=style&index=0&id=684d2880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d2880",
  null
  
)

export default component.exports